import { render, staticRenderFns } from "./statics-scale.vue?vue&type=template&id=8efb7c02"
import script from "./statics-scale.vue?vue&type=script&lang=ts"
export * from "./statics-scale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports